export enum DeviceStatus {
  Unknown,
  Checking,
  InUse,
  Available,
  NotSetup,
  Error,
}
